import { fetchApi } from '@/config/axiosSetting.ts';
import { SignUpFormDataType } from '@/modules/Auth/types/formDataType/signUpFormData.type.ts';

export const signUpMutationFunction = (formData: SignUpFormDataType) => {
  return fetchApi({
    method: 'post',
    url: 'verification/signup/',
    data: formData,
  });
};
